import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import '../propertyNewHome_styles/propertyNewHome.scss'
import { Delete_Subdivision, Edit_Property_overview } from '../Edit_Propetry/Edit_Propetry_Api'
import Swal from 'sweetalert2'
import EditSubdivision from './Components/EditSubdivision'
import { editSubdivisionDetailsDataType, propertyDetailsDataType, subdivisionReportDataDataType } from '../PropertyDataTypes'
import { Property_Report } from '../Property_Api'
import * as XLSX from 'xlsx';
interface initialValuesDataType {
  sub_unit_available: string
  number_of_subdivisions: string
  sub_units: {
    property_unit_name: string
    property_unit_description: string
    property_unit_max_tenants: string
    property_unit_rent: string
  }[]
}

const validationSchema = Yup.object().shape({
  sub_unit_available: Yup.string().required('Subdivisions is required'),
  number_of_subdivisions: Yup.string().when('sub_unit_available', (val, schema) => {
    if (val === 'true')
      return Yup.number()
        .typeError('Please enter a valid number')
        .integer('Please enter an integer')
        .required('Number of subdivisions is required')
        .max(20, 'Please enter number less than or equal to 20')
        .positive('Please enter positive integer')
    else return Yup.string().notRequired()
  }),
  sub_units: Yup.array().of(
    Yup.object().shape({
      property_unit_name: Yup.string().required('Subdivision name is required.'),
      property_unit_description: Yup.string().required('Property description is required.'),
      property_unit_max_tenants: Yup.number()
        .typeError('Please enter a valid number')
        .integer('Please enter an integer')
        .required('Number of tenants is required')
        .positive('Please enter positive integer'),
      property_unit_rent: Yup.number()
        .typeError('Please enter a valid number')
        .integer('Please enter an integer')
        .required('Expected rent is required')
        .positive('Please enter positive integer'),
    })
  ),
})

const PropertySubdivisions = ({ overviewDetails, get_view_property }: { overviewDetails: propertyDetailsDataType, get_view_property: () => Promise<void> }) => {
  const submitRef = useRef(null)
  const formRef = useRef(null)
  const editSubmitRef = useRef(null)
  const editFormRef = useRef(null)
  const [editSubdivisions, setEditSubdivisions] = useState<string>("list")
  const [editSubdivisionDetails, setEditSubdivisionDetails] = useState<editSubdivisionDetailsDataType>()
  const [editSubdivisionsLoading, setEditSubdivisionsLoading] = useState<boolean>(false)
  const [propertyReportDataLoading, setPropertyReportDataLoading] = useState<boolean | undefined>(false)

  // function to get property report 
  async function getPropertyReport() {
    if (overviewDetails?.property_uuid) {
      setPropertyReportDataLoading(true)
      try {
        const { data: res } = await Property_Report(overviewDetails?.property_uuid)
        if (res.code === "200") {
          handleGeneratePropertyReport(res.data)
        }
        else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: res.msg_details,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      }
      finally {
        setPropertyReportDataLoading(false)
      }
    }
  }

  const handleGeneratePropertyReport = (reportData: subdivisionReportDataDataType) => {
    const excelfile = XLSX.utils.book_new();
    const header1 = ["SL No.", "Property Name", "Sub Unit Name", "Tenant Name", "Tenant Email", "Tenant Contact No.", 'Expected Rent(₹)', 'Realized Rent(₹)', "Description"]
    const workSheet = XLSX.utils.json_to_sheet(reportData.main, { header: header1 });
    const colWidths = [{ wpx: 40 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }];
    workSheet['!cols'] = colWidths;
    XLSX.utils.book_append_sheet(excelfile, workSheet, "Main");
    var header = ["SL NO.", "Month", "Payment Due Date", "Invoice Type", "Payment Mode", "Paid Amount(₹)", "Payment Status"];
    for (const sheet in reportData.transactions) {
      const workSheet = XLSX.utils.json_to_sheet(reportData.transactions[sheet], { header: header });
      const colWidths = [{ wpx: 40 }, { wpx: 80 }, { wpx: 150 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 100 }];
      workSheet['!cols'] = colWidths;
      XLSX.utils.book_append_sheet(excelfile, workSheet, sheet);
    }
    XLSX.writeFile(excelfile, `${overviewDetails.property_title.charAt(0).toUpperCase() + overviewDetails.property_title.slice(1)} Property Report.xlsx`);
  }

  const handleSubmit = () => {
    if (formik.values.sub_unit_available === 'true') {
      formik.validateForm().then(async (error: any) => {
        if (Object.keys(error).length === 0) {
          setEditSubdivisionsLoading(true)
          try {
            const { data: res } = await Edit_Property_overview(
              overviewDetails.property_uuid,
              overviewDetails.property_type_uuid,
              overviewDetails.property_title,
              overviewDetails.carpet_area,
              overviewDetails.carpet_area_unit_uuid,
              overviewDetails.address_1,
              overviewDetails.address_2,
              overviewDetails.country_id,
              overviewDetails.province_id,
              overviewDetails.city,
              overviewDetails.pin_zip,
              overviewDetails.current_rent,
              overviewDetails.account_kyc_uuid,
              formik.values.sub_unit_available === 'true' ? true : false,
              overviewDetails.property_usage_type,
              overviewDetails.property_furnishing_status,
              [...overviewDetails.sub_units, ...formik.values.sub_units],
              overviewDetails.inventoryDetails
            )
            if (res.code === '200') {
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                text: res.msg_details,
                allowOutsideClick: true,
              })
              // getProperty()
              get_view_property()
              setEditSubdivisions("list")
              formik.resetForm()
            } else {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
                text: res.msg_details,
                allowOutsideClick: true,
              })
            }
          }
          catch (error: any) {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Error',
              text: error,
              allowOutsideClick: true,
            })
          }
          finally {
            setEditSubdivisionsLoading(false)
          }
        } else {
          const firstErrorField = Object.keys(error)[0]
          if (firstErrorField) {
            // @ts-ignore
            const fieldElement = formRef.current?.elements[firstErrorField] as
              | HTMLElement
              | undefined
            if (fieldElement) {
              fieldElement.scrollIntoView({ behavior: 'smooth' })
            }
          }
        }
      })
    } else {
      setEditSubdivisions("list")
    }
  }

  const initialValues: initialValuesDataType = {
    sub_unit_available: '',
    number_of_subdivisions: '',
    sub_units: [],
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: () => handleSubmit(),
  })

  const handleDeleteSubdivision = async (property_sub_unit_uuid: string) => {
    Swal.fire({
      title: 'Are you sure you want to archive subdivision?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { data: res } = await Delete_Subdivision(
            property_sub_unit_uuid
          )
          if (res.code === '200') {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
              text: res.msg_details,
              allowOutsideClick: true,
            })
            get_view_property()
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
              text: res.msg_details,
              allowOutsideClick: true,
            })
          }
        }
        catch (error: any) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error',
            text: error,
            allowOutsideClick: true,
          })
        }
      }
    })
  }

  useEffect(() => {
    const sub_units: any = []
    if (/^[0-9]+(\.{1})?$/.test(formik.values.number_of_subdivisions)) {
      // @ts-ignore
      if (
        parseInt(formik.values?.number_of_subdivisions, 10) >= 1 &&
        parseInt(formik.values?.number_of_subdivisions, 10) <= 20
      ) {
        for (let i = 0; i < parseInt(formik.values.number_of_subdivisions, 10); i++) {
          sub_units.push({
            property_sub_unit_uuid: '',
            property_unit_name: '',
            property_unit_description: '',
            property_unit_max_tenants: '1',
            property_unit_rent: '',
          })
        }
      }
    }
    formik.setValues({ ...formik.values, sub_units })
  }, [formik.values.number_of_subdivisions])

  const handleDuplicateSubmit = () => {
    if (editSubdivisions === "add") {
      if (submitRef !== null) {
        // @ts-ignore
        submitRef?.current.click()
      }
    }
    else if (editSubdivisions === "edit") {
      if (editSubmitRef !== null) {
        // @ts-ignore
        editSubmitRef?.current.click()
      }
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header cursor-pointer'>
        {/* Begin: Subdivisions heading */}
        <div className='card-title m-0'>
          <h3 className='fw-bold m-0'>Subdivisions</h3>
        </div>
        <div className='d-flex'>
          {editSubdivisions === "add" || editSubdivisions === "edit" ? (
            <div className='align-self-center'>
              <button
                className='btn btn-sm btn-light fw-bold bg-color-white shadow me-4 btn-active-light-primary'
                onClick={() => setEditSubdivisions("list")}
              >
                Cancel
              </button>
              <button
                type='submit'
                className='btn btn-sm btn-primary shadow'
                onClick={handleDuplicateSubmit}
                disabled={editSubdivisionsLoading}
              >
                {editSubdivisionsLoading ? (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    Processing...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <span>Save</span>
                )}
              </button>
            </div>
          ) : (
            <div className='d-flex'>
              {
                (overviewDetails.sub_unit_available && overviewDetails.sub_units.length > 0) &&
                <div className='min-w-200px align-self-center'>
                  <button type='button' className='btn btn-sm fw-bold btn-primary me-2'
                    onClick={() => getPropertyReport()}
                    disabled={propertyReportDataLoading}
                  >
                    {
                      propertyReportDataLoading ?
                        <span className='indicator-progress' style={{ display: 'block' }}>
                          Processing...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                        :
                        <span className='indicator-label'>Generate Properties Report</span>
                    }
                  </button>
                </div>
              }
              <button
                className='align-self-center btn btn-sm btn-primary me-3'
                onClick={() => setEditSubdivisions("add")}
              >
                Add Subdivisions
              </button>
            </div>
          )}

        </div>
      </div>
      {(editSubdivisions === "edit" && editSubdivisionDetails) ?
        <EditSubdivision
          editSubmitRef={editSubmitRef}
          editFormRef={editFormRef}
          editSubdivisionDetails={editSubdivisionDetails}
          get_view_property={get_view_property}
          setEditSubdivisions={setEditSubdivisions}
          setEditSubdivisionsLoading={setEditSubdivisionsLoading}
          editSubdivisionsLoading={editSubdivisionsLoading} />
        :
        editSubdivisions === "add" && overviewDetails ? (
          <form ref={formRef} onSubmit={formik.handleSubmit} className='form'>
            <div className='card-body p-9 row'>
              {/*begin::Form Group */}
              <div className='row mb-6'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>Add subdivisions</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Select whether property have subdivisions'
                  ></i>
                </label>
                <div className='row'>
                  {/*begin:Option */}
                  <label className='col-lg-6 col-12 d-flex flex-basis-50 align-items-center justify-content-between cursor-pointer'>
                    <span className='d-flex align-items-center me-2'>
                      <span className='symbol symbol-50px me-2'>
                        <span className='symbol-label bg-light-primary'>
                          <i className='bi bi-check-square fs-2x'></i>
                        </span>
                      </span>

                      <span className='d-flex flex-column'>
                        <span className='fw-bolder fs-6'>Yes</span>
                      </span>
                    </span>

                    <span className='form-check form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        {...formik.getFieldProps('sub_unit_available')}
                        name='sub_unit_available'
                        type='radio'
                        value='true'
                        id='sub_unit_available'
                      // defaultChecked={overviewDetails?.sub_unit_available === true}
                      />
                    </span>
                  </label>
                  {/*end::Option */}

                  {/*begin:Option */}
                  <label className='col-lg-6 col-12 d-flex flex-basis-50 align-items-center justify-content-between cursor-pointer'>
                    <span className='d-flex align-items-center me-2'>
                      <span className='symbol symbol-50px me-2'>
                        <span className='symbol-label bg-light-danger'>
                          <i className='bi bi-x-square fs-2x'></i>
                        </span>
                      </span>

                      <span className='d-flex flex-column'>
                        <span className='fw-bolder fs-6'>No</span>
                      </span>
                    </span>

                    <span className='form-check form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        {...formik.getFieldProps('sub_unit_available')}
                        name='sub_unit_available'
                        type='radio'
                        value='false'
                        id='sub_unit_available'
                        onChange={() => {
                          formik.resetForm()
                          formik.setFieldValue('sub_unit_available', 'false')
                        }}
                      // defaultChecked={overviewDetails?.sub_unit_available === false}
                      />
                    </span>
                  </label>
                  {/*end::Option */}
                </div>
                <div className='h-20px'>
                  {formik.touched.sub_unit_available && formik.errors.sub_unit_available && (
                    <div className='fv-help-block color-red'>{formik.errors.sub_unit_available}</div>
                  )}
                </div>
              </div>
              {/*end::Form Group */}
              {formik.values.sub_unit_available === 'true' && (
                <>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>
                      <span className='required'>Number of subdivisions</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Specify number of subdiviions present in property'
                      ></i>
                    </label>
                    <div className='col-lg-8 fv-row'>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Enter number of subdivisions'
                        {...formik.getFieldProps('number_of_subdivisions')}
                      />
                      {formik.touched.number_of_subdivisions && formik.errors.number_of_subdivisions && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            {formik.errors.number_of_subdivisions.toString()}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {parseInt(formik.values.number_of_subdivisions, 10) > 0 &&
                    !formik.errors.number_of_subdivisions &&
                    Array.from({ length: parseInt(formik.values.number_of_subdivisions, 10) }).map(
                      (_, index) => (
                        <>
                          <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label fw-bolder fs-6'>
                              <span className='required fs-2'>{`Room ${index + 1}`}</span>
                            </label>
                          </div>

                          <div className='row mb-6'>
                            <div className='col-lg-6 col-12'>
                              <div>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                  <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                    <span className='required'>Subdivision Name</span>
                                    <i
                                      className='fas fa-exclamation-circle ms-2 fs-7'
                                      data-bs-toggle='tooltip'
                                      title='Enter subdivision name'
                                    ></i>
                                  </label>
                                  <input
                                    type='text'
                                    className='form-control form-control-lg form-control-solid'
                                    placeholder='Enter subdivision name'
                                    {...formik.getFieldProps(
                                      `sub_units[${index}].property_unit_name`
                                    )}
                                  />
                                  <div className='h-20px'>
                                    {formik.touched.sub_units &&
                                      formik.touched.sub_units[index] &&
                                      // @ts-ignore
                                      formik.touched.sub_units[index].property_unit_name &&
                                      formik.errors.sub_units &&
                                      formik.errors.sub_units[index] &&
                                      // @ts-ignore
                                      formik.errors.sub_units[index].property_unit_name && (
                                        <div className='fv-help-block color-red'>
                                          {
                                            // @ts-ignore
                                            formik.errors.sub_units[index].property_unit_name
                                          }
                                        </div>
                                      )}
                                  </div>
                                </div>
                                {/*end::Form Group */}
                              </div>
                              <div className=''>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                  <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                    <span className='required'>Number of Tenant</span>
                                    <i
                                      className='fas fa-exclamation-circle ms-2 fs-7'
                                      data-bs-toggle='tooltip'
                                      title='Enter number of tenant'
                                    ></i>
                                  </label>
                                  <input
                                    type='number'
                                    className='form-control form-control-lg form-control-solid'
                                    placeholder='Enter number of tenant'
                                    {...formik.getFieldProps(
                                      `sub_units[${index}].property_unit_max_tenants`
                                    )}
                                    name={`sub_units[${index}].property_unit_max_tenants`}
                                    disabled
                                  />
                                  <div className='h-20px'>
                                    {formik.touched.sub_units &&
                                      formik.touched.sub_units[index] &&
                                      // @ts-ignore
                                      formik.touched.sub_units[index].property_unit_max_tenants &&
                                      formik.errors.sub_units &&
                                      formik.errors.sub_units[index] &&
                                      // @ts-ignore
                                      formik.errors.sub_units[index].property_unit_max_tenants && (
                                        <div className='fv-help-block color-red'>
                                          {
                                            // @ts-ignore
                                            formik.errors.sub_units[index].property_unit_max_tenants
                                          }
                                        </div>
                                      )}
                                  </div>
                                </div>
                                {/*end::Form Group */}
                              </div>
                              <div className=''>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                  <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                    <span className='required'>Expected Rent</span>
                                    <i
                                      className='fas fa-exclamation-circle ms-2 fs-7'
                                      data-bs-toggle='tooltip'
                                      title='Enter expected rent'
                                    ></i>
                                  </label>
                                  <input
                                    type='number'
                                    className='form-control form-control-lg form-control-solid'
                                    placeholder='Enter expected rent'
                                    {...formik.getFieldProps(
                                      `sub_units[${index}].property_unit_rent`
                                    )}
                                  />
                                  <div className='h-20px'>
                                    {formik.touched.sub_units &&
                                      formik.touched.sub_units[index] &&
                                      // @ts-ignore
                                      formik.touched.sub_units[index].property_unit_rent &&
                                      formik.errors.sub_units &&
                                      formik.errors.sub_units[index] &&
                                      // @ts-ignore
                                      formik.errors.sub_units[index].property_unit_rent && (
                                        <div className='fv-help-block color-red'>
                                          {
                                            // @ts-ignore
                                            formik.errors.sub_units[index].property_unit_rent
                                          }
                                        </div>
                                      )}
                                  </div>
                                </div>
                                {/*end::Form Group */}
                              </div>
                            </div>
                            <div className='col-lg-6 col-12'>
                              <div className=''>
                                {/*begin::Form Group property title */}
                                <div className='fv-row'>
                                  <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                                    <span className='required'>Subdivision Description</span>
                                    <i
                                      className='fas fa-exclamation-circle ms-2 fs-7'
                                      data-bs-toggle='tooltip'
                                      title='Enter subdivision description'
                                    ></i>
                                  </label>
                                  <textarea
                                    rows={9}
                                    cols={200}
                                    disabled={false}
                                    className='form-control form-control-lg form-control-solid'
                                    placeholder='Enter subdivision description'
                                    {...formik.getFieldProps(
                                      `sub_units[${index}].property_unit_description`
                                    )}
                                    name={`sub_units[${index}].property_unit_description`}
                                  />
                                  <div className='h-20px'>
                                    {formik.touched.sub_units &&
                                      formik.touched.sub_units[index] &&
                                      // @ts-ignore
                                      formik.touched.sub_units[index].property_unit_description &&
                                      formik.errors.sub_units &&
                                      formik.errors.sub_units[index] &&
                                      // @ts-ignore
                                      formik.errors.sub_units[index].property_unit_description && (
                                        <div className='fv-help-block color-red'>
                                          {
                                            // @ts-ignore
                                            formik.errors.sub_units[index].property_unit_description
                                          }
                                        </div>
                                      )}
                                  </div>
                                </div>
                                {/*end::Form Group */}
                              </div>
                            </div>
                          </div>
                          <hr />
                        </>
                      )
                    )}
                </>
              )}
              <div className='card-footer d-flex justify-content-end py-6 px-3'>
                <button
                  className='btn btn-sm btn-light fw-bold bg-color-white shadow me-4 btn-active-light-primary'
                  onClick={() => setEditSubdivisions("list")}
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-sm btn-primary shadow'
                  ref={submitRef}
                  disabled={editSubdivisionsLoading}
                >
                  {editSubdivisionsLoading ? (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Processing...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    'Save'
                  )}
                </button>
              </div>
            </div>
          </form>
        ) : overviewDetails?.sub_unit_available ? (
          <div className='p-9 row'>
            <div className='col-md-6 ms-4'>
              <div className='row mb-6'>
                <label className='col-lg-6 fw-bold text-muted'>Do property have subdivisions?</label>
                <div className='col-lg-6'>
                  <span className='fw-bold fs-6 pb-1'>
                    {overviewDetails?.sub_unit_available && 'Yes'}
                  </span>
                </div>
              </div>
            </div>
            {/* {
            overviewDetails?.sub_unit_available &&  */}
            <div className='row g-3'>
              {overviewDetails.sub_units.map((subdivision, index: number) => {
                return (
                  <div className='col-lg-4 col-12' key={subdivision.property_sub_unit_uuid}>
                    <div
                      className='shadow-sm bg-white rounde card'>
                      {/* begin::Header */}
                      <div className='p-4'>
                        <div className='d-flex align-items-center'>
                          {/* begin::User */}
                          <div className='d-flex align-items-center flex-grow-1'>
                            {/* begin::Avatar */}
                            <div className='symbol symbol-45px me-5'>
                              <i className='bi bi-house-door fs-2x symbol bg-light-primary'></i>
                            </div>
                            {/* end::Avatar */}

                            {/* begin::Info */}
                            <div className='d-flex flex-column'>
                              <span className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                                {subdivision.property_unit_name}
                              </span>

                              <span className='text-gray-400 fw-semibold'>{`Room ${index + 1}`}</span>
                            </div>
                            {/* end::Info */}
                          </div>
                          {/* end::User */}
                        </div>
                        {/* end::Header */}
                        {/* begin::Text */}
                        <p className='text-gray-800 fw-normal my-5'>
                          {subdivision.property_unit_description}
                        </p>
                        {/* end::Text */}
                        {/* begin::Toolbar */}
                        <div className='row align-items-center h-75px gap-3 justify-content-center'>
                          <span className='border border-light col-5 btn btn-sm btn-light btn-color-muted btn-active-light-primary py-2 h-75px'>
                            <div className='fs-6 text-primary fw-bold'>{`₹ ${subdivision.property_unit_rent}`}</div>
                            <div className='fs-6 text-gray-400'>Expected rent</div>
                          </span>
                          <span className='border border-light col-5 btn btn-sm btn-light btn-color-muted btn-active-light-primary py-2 h-75px'>
                            <div className='fs-6 text-primary fw-bold'>
                              {subdivision.property_unit_max_tenants}
                            </div>
                            <div className='fs-6 text-gray-400'>Number of Tenants</div>
                            {/* </div> */}
                          </span>
                        </div>
                      </div>
                      {/* end::Post */}
                      {/* <hr className='p-0 m-0'/> */}
                      <div className='row w-100 m-0 justify-content-center'>
                        <button
                          className='border border-secondary p-0 h-30px btn btn-light btn-sm col-6 rounded-0 rounded-bottom image_icon'
                          title='Edit'
                          onClick={() => {
                            setEditSubdivisions("edit");
                            setEditSubdivisionDetails(subdivision);
                          }}
                        >
                          <i className='bi bi-pencil-square fa-md fs-2'></i>
                          <span>Edit</span>
                        </button>
                        <button
                          className='border border-secondary p-0 h-30px btn btn-light btn-sm col-6 rounded-0 rounded-bottom image_icon'
                          title='Archive'
                          onClick={() => handleDeleteSubdivision(subdivision.property_sub_unit_uuid)}
                        >
                          <i className='bi bi-trash text-danger fa-md fs-2'></i>
                          <span>Archive</span>
                        </button>
                      </div>
                    </div>

                  </div>
                )
              })}
            </div>
          </div>
        ) : (
          <div className='d-flex flex-column align-items-center flex-start p-10'>
            <img
              src='/media/svg/undraw/subdivision.svg'
              alt='No document uploaded'
              className='h-200px w-200px'
            />
            <span className='fw-bold text-muted fs-1 text-center'>No Subdivisions Added!</span>
          </div>
        )}
    </div>
  )
}

export default PropertySubdivisions
